import React from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';

import { Box, Tooltip, Text } from '@nerdwallet/currency';
import num from '@nerdwallet/nw-client-lib/num';
import { getFieldValueByCalculator } from '../utils';

import type { MonthlyPaymentInputProps } from '../types';

const DownPaymentInput = (props: MonthlyPaymentInputProps): JSX.Element => {
  const {
    value,
    label = 'Down Payment',
    tooltip = 'The initial portion of the home price that is required at the time of purchase.',
  } = props;

  const currencyValue = _.isNil(value) ? '' : num.formatCurrency(value);

  const tooltipLabel = label;

  return (
    <Box display="flex" justifyContent="space-between">
      <Box>
        {/* @ts-ignore - ignore type error for label */}
        <Tooltip label={tooltipLabel} content={tooltip} />
      </Box>
      <Box>
        <Text size="small" bold>
          {currencyValue}
        </Text>
      </Box>
    </Box>
  );
};

const mapStateToProps = (state, ownProps: MonthlyPaymentInputProps) => {
  const { calculator } = ownProps;
  return {
    value: getFieldValueByCalculator(state, calculator, 'downPayment'),
  };
};

export default connect(mapStateToProps)(DownPaymentInput);
